import { Link } from 'react-router-dom';
import type { Video } from '@/types';
import { videoTypeLabels } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
  showStatus?: boolean;
}

export default function VideoCard({ video, showStatus = true }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block"
      title={`${video.title} - ${videoTypeLabels[video.type]}`}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <img
          src={video.poster}
          alt={`${video.title} 海报`}
          title={`${video.title} 高清海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-background-50/10 to-transparent" />
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-50/85 px-2 py-0.5 text-xs font-semibold text-accent-500 backdrop-blur-sm">
          <i className="ri-star-fill text-xs" />
          {video.rating.toFixed(1)}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {videoTypeLabels[video.type]}
        </span>
        {showStatus && (
          <span className="absolute bottom-2 left-2 rounded bg-background-50/80 px-1.5 py-0.5 text-[11px] text-foreground-200 backdrop-blur-sm">
            {video.status}
          </span>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl" />
          </span>
        </div>
      </div>
      <h3 className="mt-2 line-clamp-1 text-sm font-medium text-foreground-100 transition-colors group-hover:text-primary-500">
        {video.title}
      </h3>
      <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
        {video.genres.slice(0, 2).join(' / ')} · {video.year}
      </p>
    </Link>
  );
}